import { useCallback, useEffect, useState } from "react";
import { getLibraryPlaylists } from "../api/libraryApi";
import { toLibraryPlaylists } from "../helpers/libraryTransformers";

export default function useLibraryPlaylists() {
  const [playlists, setPlaylists] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [loadError, setLoadError] = useState("");

  const loadPlaylists = useCallback(async () => {
    setIsLoading(true);
    setLoadError("");
    try {
      const response = await getLibraryPlaylists();
      setPlaylists(toLibraryPlaylists(response));
    } catch (error) {
      console.error("Failed to load library playlists", error);
      setLoadError(
        typeof error === "string"
          ? error
          : "Failed to load playlists from My Playlists."
      );
      setPlaylists([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    loadPlaylists();
  }, [loadPlaylists]);

  return {
    playlists,
    isLoading,
    loadError,
    loadPlaylists,
  };
}
